import type { ReactNode } from 'react';

interface AlertProps {
  variant?: 'error' | 'info' | 'success';
  children: ReactNode;
}

export function Alert({ variant = 'error', children }: AlertProps) {
  return (
    <div className={`alert alert--${variant}`} role={variant === 'error' ? 'alert' : 'status'}>
      {children}
    </div>
  );
}
